import { createStore, applyMiddleware, compose } from 'redux'
import reducers from './reducers/referenten'
import thunkMiddleware from 'redux-thunk'

export default function configureStore(initialState = {}) {
    const middlewares = [thunkMiddleware]
    const enhancers = [applyMiddleware(...middlewares)]
    const store = createStore(reducers, initialState, compose(...enhancers))

    store.asyncReducers = {} // Async reducer registry

    return store
}


// WEBPACK FOOTER //
// ./src/storeReferenten.js